import { ApiModule } from "../modules/api.module";
import { AuthModule } from "../modules/auth.module";
import { AuthorizationModule } from "../modules/authorization.module";
import { CoreModule } from "../modules/core.module";
import { HttpModule } from "../modules/http.module";
import { SettingsModule } from "../modules/settings.module";
import { DispatcherModule } from "../modules/dispatcher.module";
import { RoutingModule } from "../modules/routing.module";

const start = () => {
  const coreModule = new CoreModule();

  const settingsModule = new SettingsModule({
    path: '../../config.{env}.json',
    environment: 'LOCAL',
    source: 'IMPORT',
  });

  settingsModule.configureServices(coreModule.serviceProvider);
  coreModule.configureServices(coreModule.serviceProvider, coreModule.serviceProvider.resolve('config-provider')!);
  const modules = [
    new DispatcherModule(),
    new RoutingModule(),
    new AuthModule(),
    new HttpModule(),
    new ApiModule(),
    new AuthorizationModule(),
  ]
  modules.forEach(module => module.configureServices(coreModule.serviceProvider, coreModule.serviceProvider.resolve('config-provider')!));
  return {modules, serviceProvider: coreModule.serviceProvider};
}
export const applicationStartup = () => {
  return {
    start
  }
}
